type TranslationFunction = (key: string) => string;

type DreamPodConfig = {
  image: {
    src: string;
    alt: string;
  };
  title: string;
  description: string;
  sizeClasses: string;
};

const getDreamPodsConfig = (t: TranslationFunction): DreamPodConfig[] => [
  {
    image: {
      src: t('pods.pod_1.image.src'),
      alt: t('pods.pod_1.image.alt'),
    },
    title: t('pods.pod_1.title'),
    description: t('pods.pod_1.description'),
    sizeClasses: 'w-[109px] sm:w-[174px] md:w-[330px] h-[112px] sm:h-[178px] md:h-[373px]',
  },
  {
    image: {
      src: t('pods.pod_2.image.src'),
      alt: t('pods.pod_2.image.alt'),
    },
    title: t('pods.pod_2.title'),
    description: t('pods.pod_2.description'),
    sizeClasses: 'w-[163px] sm:w-[259px] md:w-[324px] h-[168px] sm:h-[267px] md:h-[315px]',
  },
  {
    image: {
      src: t('pods.pod_3.image.src'),
      alt: t('pods.pod_3.image.alt'),
    },
    title: t('pods.pod_3.title'),
    description: t('pods.pod_3.description'),
    sizeClasses: 'w-[116px] sm:w-[185px] md:w-[245px] h-[120px] sm:h-[191px] md:h-[279px]',
  },
  {
    image: {
      src: t('pods.pod_4.image.src'),
      alt: t('pods.pod_4.image.alt'),
    },
    title: t('pods.pod_4.title'),
    description: t('pods.pod_4.description'),
    sizeClasses: 'w-[116px] sm:w-[185px] md:w-[324px] h-[120px] sm:h-[191px] md:h-[315px]',
  },
];

export { getDreamPodsConfig };
export type { DreamPodConfig };
